import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BadgeComponent} from './badge.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    BadgeComponent,
  ],
  exports: [
    BadgeComponent,
  ],
})
export class BadgeModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/badges/components/badge-component/badge.module.ts